export default "__VITE_ASSET__38280fbc__"